export const EMPTY_STRING = '';

export const COMMA = ',';

export const SPACE = ' ';

export const VERTICAL_LINE_SIGN = '|';
